import { render } from "./sheet-change-password.vue?vue&type=template&id=10e9b45c"
import script from "./sheet-change-password.vue?vue&type=script&lang=js"
export * from "./sheet-change-password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__